export default __webpack_public_path__ + "static/source-code-pro-v11-latin-regular-4da4c19319100df7734c4643db00d6c7.woff";